(function(){
  var root=document.querySelector('.ref-rd'); if(!root) return;
  var card=root.querySelector('.offer-card'), cta=root.querySelector('.offer-cta .tier-btn');
  if(card && !card.id) card.id='ref-offer';

  /* A tap never leaves a focus ring behind for the next keystroke; keyboard activation (detail 0) keeps focus. */
  root.addEventListener('click',function(e){
    var btn=e.target.closest && e.target.closest('.tier-btn,.rp-bar-btn');
    if(btn && e.detail>0) btn.blur();
  });

  /* Header "Book now" on THIS page books the referral offer (same handler as the card button),
     not the full-price builder. Without JS it falls back to the offer card. */
  var hb=document.querySelector('a.booknow');
  if(hb && card){
    hb.setAttribute('href','#ref-offer');
    if(cta) hb.addEventListener('click',function(e){ e.preventDefault(); if(e.detail>0) hb.blur(); cta.click(); });
  }

  /* Sticky bar: the builder's bottom bar. Hidden while the card's own button is on screen. */
  var bar=root.querySelector('.rp-bar'); if(!bar || !cta) return;
  bar.querySelector('.rp-bar-btn').addEventListener('click',function(){ cta.click(); });
  var ctaVisible=false, endReached=false;
  function sync(){ bar.dataset.hidden = (ctaVisible || endReached) ? 'true' : 'false'; }
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){ es.forEach(function(e){ ctaVisible=e.isIntersecting; }); sync(); },{threshold:0.5}).observe(cta);
    /* the fine print and everything after it: the bar never sits over them */
    var fine=root.querySelector('.footer');
    if(fine) new IntersectionObserver(function(es){ es.forEach(function(e){ endReached=e.isIntersecting || e.boundingClientRect.top < 0; }); sync(); }).observe(fine);
  }
  else { endReached=true; } /* no observer: never risk covering the card button or the fine print */
  sync();
})();
